const initCapitalize = (str: string | null | undefined): string => {
	if (!str) return "";
	/* eslint-disable-next-line arrow-parens */
	return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

export default initCapitalize;
